module.exports = __webpack_public_path__ + "img/06912613e50e5e64225fc29521f6bace.png";